/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */
import { Head, router, useForm, usePage } from "@inertiajs/react"

import { ProductForm } from "@/components/products/product-form"
import AppLayout from "@/layouts/app-layout"
import { marketplaceProductsPath, productsCreatePath } from "@/routes"

interface ProductsNewProps {
  product: Record<string, unknown>
  categories: { id: number; name: string }[]
  businesses?: { id: number; business_name: string }[]
}

export default function ProductsNew({
  categories,
  businesses = [],
}: ProductsNewProps) {
  const page = usePage()
  const search = page.url.includes("?") ? page.url.split("?")[1] : ""
  const params = new URLSearchParams(search)
  const from = params.get("from")

  const { data, setData, post, processing, errors } = useForm<any>({
    product: {
      name: "",
      description: "",
      price: "",
      sale_price: "",
      currency: "EUR",
      in_stock: true,
      stock_quantity: "10",
      unit: "",
      category_id: categories?.[0] ? String(categories[0].id) : "",
      business_id: businesses?.[0] ? String(businesses[0].id) : "",
      status: "active",
      condition: "new",
      tags: "",
      images: [],
      image_urls: [],
    },
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    post(productsCreatePath(), { forceFormData: true })
  }

  const handleCancel = () => {
    if (from) {
      router.visit(from)
    } else {
      router.visit(marketplaceProductsPath())
    }
  }

  const err = errors as unknown as Record<string, string>

  return (
    <AppLayout>
      <Head title="Crear producto" />
      <div className="mx-auto max-w-6xl p-4 md:p-6">
        <ProductForm
          title="Crear producto"
          data={data.product}
          errors={err}
          categories={categories}
          businesses={businesses}
          processing={processing}
          onChange={(partial) =>
            setData("product", { ...data.product, ...partial })
          }
          onSubmit={submit}
          onCancel={handleCancel}
          submitLabel="Guardar"
        />
      </div>
    </AppLayout>
  )
}
